<template>
    <div :class="classNamesElement">
        <label :for="id" v-if="label"><translate>{{ label }}</translate></label>
        <QuillEditor theme="snow" :name="id" :id="id" v-model:content="proxyModelValue" @update:content="$emit('update:modelValue', $event)" content-type="html" ref="quill" />
        <span v-if="errorOrInfo" class="form-info">{{ errorOrInfo }}</span>
    </div>
</template>

<script>

import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';

export default {
    name: 'FormHtml',
    components: {
        QuillEditor,
    },
    props: [
        'modelValue',
        'id',
        'type',
        'label',
        'placeholder',
        'required',
        'autofocus',
        'autocomplete',
        'error',
        'info',
        'disabled',
        'icon',
        'height',
    ],
    data() {
      return {
          editor: null,
          proxyModelValue: this.modelValue,
      };
    },
    computed: {
        classNamesElement() {
            let classNames = ['form-element'];
            if (this.error) classNames.push('form-element--error');
            if (!this.error && this.modelValue) classNames.push('form-element--valid');
            if (this.icon) classNames.push('form-element--icon');
            if (this.modelValue) classNames.push('form-element--filled');

            return classNames;
        },
        errorOrInfo() {
            return this.error ? this.error : this.info;
        },
        inputHeight() {
            return this.height ? this.height : '100px';
        },
    },
    emits: ['update:modelValue', 'set-html'],
    methods: {
        focus() {
            this.$refs.input.focus();
        },
        updateEditor(text) {
            this.proxyModelValue = text;
            this.$refs.quill.setHTML(text);
        }
    },
};
</script>

<style scoped>
div :deep() .ql-snow .ql-editor h1 {
    font-size: 18px;
    line-height: 18px;
    font-weight: bold;
    margin: 0 0 16px;
}

div :deep() .ql-snow .ql-editor p {
    font-size: 14px;
    line-height: 18px;
    margin: 0 0 16px;
}

div :deep() .ql-snow .ql-editor ul,
div :deep() .ql-snow .ql-editor ol {
    font-size: 14px;
    line-height: 18px;
    margin: 0 0 16px;
}
</style>
